import * as React from "react";
type Props = {
  className?: string,
};
function SvgCaretDownNew({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-caret-down-new"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3165 16.573L4 8.34204L5.3671 7.12684L12 14.5889L18.6329 7.12684L20 8.34204L12.6835 16.573C12.51 16.7683 12.2612 16.88 12 16.88C11.7388 16.88 11.49 16.7683 11.3165 16.573Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgCaretDownNew;
